import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from '@lumal/lib';
import { API } from '../api';
import { btnSecondary, userBar } from '../styles';
import type { MeResponse } from '../types';

export function UserBar({ user, csrf }: { user: NonNullable<MeResponse['user']>; csrf: string }) {
  const qc = useQueryClient();
  const logoutMut = useMutation({
    mutationFn: () => logout(API, csrf),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me'] }),
  });
  return (
    <header style={userBar}>
      <span data-testid="user-greeting">
        <strong>{user.name || user.email}</strong> <small>({user.roles.join(', ')})</small>
      </span>
      <button style={btnSecondary} onClick={() => logoutMut.mutate()} data-testid="logout-button">
        Cerrar sesión
      </button>
    </header>
  );
}
